import { useState } from "react";
import { ProductListItemAvailability } from "./product_list_item_availability";

export const ProductListItem = (props) => {
  const [hover, setHover] = useState(false);

  const removeIcon =
    props.selectedCategoryItemsIds.indexOf(props.product.pr_id) >= 0 ? (
      <img
        src={props.removeImageUrl}
        style={{
          position: "relative",
          float: "right",
          margin: "8px -1px -29px 0px",
        }}
        onClick={() =>
          ts.props.removeFromCategorySelection(props.product, props.category)
        }
        title="Odebrat z výběru"
      />
    ) : null;

  var boxInnerStyles = { height: 498, width: 293 };

  if (props.selectedCategoryItemsIds.indexOf(props.product.pr_id) >= 0) {
    boxInnerStyles.backgroundColor = "#EFF5F9";
    boxInnerStyles.zIndex = 9;
  }

  if (hover) {
    boxInnerStyles.height = 518;
    boxInnerStyles.width = 313;
  }

  return (
    <li
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="magnific-popup"></div>
      <div className="product-box-inner" style={boxInnerStyles}>
        {removeIcon}
        <h2
          className="title"
          style={{ marginBottom: 0, marginTop: 5, maxWidth: 259 }}
        >
          <a
            onClick={() => {
              openModalProductDetail(props.product.link);
            }}
          >
            {props.product.name}
          </a>
        </h2>

        <div className="row" style={{ height: 16, marginTop: 0 }}>
          <div
            className="col-lg-6"
            dangerouslySetInnerHTML={{ __html: props.product.stars }}
          />
        </div>

        <div className="image-container" style={{ marginLeft: -5 }}>
          <div
            className="image-box"
            onClick={() => {
              openModalProductDetail(props.product.link);
            }}
          >
            <img src={props.product.image_url} />
          </div>
        </div>
        <div className="prices-and-availability" style={{ padding: "0 2px" }}>
          <div className="prices" style={{ marginTop: 3, width: "47%" }}>
            <strong className="current-price">
              {formatMoney(props.product.price)}
            </strong>
          </div>
          <div className="availability" style={{ paddingTop: 0 }}>
            <strong className="available-quantity" style={{ marginRight: 0 }}>
              {props.product.quantity_in_stock_label}
            </strong>

            <div className="availability-state.in-stock">
              u vás doma {props.product.delivery_date}
            </div>
          </div>
        </div>
        <p className="param-summary">{props.product.summary}</p>
        <div className="actions-no-hover" style={{ textAlign: "center" }}>
          {addOrRemoveButton()}
        </div>
      </div>
    </li>
  );

  function addOrRemoveButton() {
    var disabledClass = props.productAddingInProgress ? " disabled" : "";
    var cssClasses = "detail-link button button-primary" + disabledClass;

    if (props.selectedCategoryItemsIds.indexOf(props.product.pr_id) >= 0) {
      return (
        <div
          className={cssClasses}
          onClick={() =>
            props.removeFromCategorySelection(props.product, props.category)
          }
          style={{
            backgroundColor: "#0054a1",
            padding: "11px 46px",
            width: 184,
          }}
        >
          {hover ? "Odebrat ze setu" : "Vybráno v setu"}
        </div>
      );
    } else {
      return (
        <div
          className={cssClasses}
          onClick={() =>
            props.addToCategorySelection(props.product, props.category)
          }
          style={{ padding: "11px 46px" }}
        >
          Přidat do setu
        </div>
      );
    }
  }
};
